import { catchError } from "rxjs/operators";
import { UntypedFormGroup } from "@angular/forms";
import { Injectable } from "@angular/core";
import {
  AppBarActionsService,
  AppPageService,
  CommonActionKey,
  MessageService,
  SimpleDialogService,
} from "common";
import { EMPTY, Observable } from "rxjs";
import { AccountService } from "../../../account.service";
import { AccountStatementsRequestData } from "../../../account.model";

@Injectable()
export class AccountStatementsEditFacade {
  constructor(
    private readonly appBarActionsService: AppBarActionsService,
    private readonly appPageService: AppPageService,
    private readonly accountService: AccountService,
    private readonly messageService: MessageService,
    private readonly simpleDialogService: SimpleDialogService
  ) { }

  updateActionButtons(isFormValid: boolean): void {
    this.appBarActionsService.enable("save", isFormValid);
  }

  cancel(): void {
    this.appPageService.back();
  }

  save(loanId: number, statementsForm: UntypedFormGroup): void {
    this.appBarActionsService.enable("save", false);
    const formValues = statementsForm?.value;
    const generateStatements = formValues?.generateStatements;
    const generateStatementsExpirationDate = formValues?.generateStatementsExpirationDate;
    
    const confirmText = "Manually overriding will change the current status of statement generation. <br>The new status will return to it's original status after set expired date and time";
    this.simpleDialogService.openSimpleConfirmDialog(confirmText, "Confirm override?")
      .subscribe((result: CommonActionKey) => {
        if (result !== CommonActionKey.Confirm) {
          this.appBarActionsService.enable("save", true);
          return;
        }

        const requestData: AccountStatementsRequestData = {
          generateStatements,
          generateStatementsExpirationDate,
        };

        this.updateStatementsRequest(loanId, requestData);
      });
  }

  private updateStatementsRequest(loanId: number, requestData: AccountStatementsRequestData): void {
    this.accountService.updateLoanStatementsGenearation(loanId, requestData)
      .pipe(
        catchError((error) => {
          return this.handleSaveError(error);
        })
      )
      .subscribe(() => {
        this.appPageService.back();
      });
  }

  private handleSaveError(error: unknown): Observable<never> {
    this.appBarActionsService.enable("save", true);
    this.messageService.error(error);
    return EMPTY;
  }
}
